import * as v from "valibot";

import { CheckIns } from "@/features/check-in/check-ins";

const searchSchema = v.object({
  page: v.pipe(
    v.optional(v.number(), 1),
    v.minValue(1, "page value minimum is 1."),
  ),
  pageSize: v.pipe(
    v.optional(v.number(), 20),
    v.minValue(10, "pageSize value minimum is 10."),
    v.maxValue(100, "pageSize value maximum is 100."),
  ),
  // filters
  created: v.optional(v.tuple([v.string(), v.string()])),
  filter: v.optional(v.string()),
  sort: v.optional(v.string()),
});

export const Route = createFileRoute({
  component: CheckIns,
  validateSearch: searchSchema,
});
